import PropTypes from "prop-types"
import React, { useState } from "react"

import { connect } from "react-redux"
import { Input, Button, Space, Tooltip, Popover, Grid, Typography } from "antd"
import { Link } from "react-router-dom"
import { MenuOutlined, SearchOutlined, FullscreenOutlined, FireOutlined } from "@ant-design/icons"

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

// Replaced image logos with icon + app name

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"

const Header = props => {
  const [searchOpen, setSearchOpen] = useState(false)
  const screens = Grid.useBreakpoint()

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  // Use layout handler to toggle sidebar instead of manipulating body classes directly

  const isDark = props.leftSideBarTheme === "dark"
  const headerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 12px",
    height: 64,
  position: "fixed",
    top: 0,
    left: 0,
  right: 0,
  width: "100%",
    zIndex: 100,
    // Glassy (frosted) background
    // Subtle gradient overlay + translucent layer
    background: isDark
      ? "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0) 100%), rgba(20, 20, 20, 0.55)"
      : "linear-gradient(180deg, rgba(0,0,0,0.04) 0%, rgba(0,0,0,0) 100%), rgba(255, 255, 255, 0.6)",
    backdropFilter: "saturate(180%) blur(10px)",
    WebkitBackdropFilter: "saturate(180%) blur(10px)",
    borderBottom: isDark ? "1px solid rgba(255,255,255,0.12)" : "1px solid rgba(0,0,0,0.06)",
    boxShadow: isDark
      ? "0 2px 10px rgba(0,0,0,0.35)"
      : "0 2px 10px rgba(0,0,0,0.06)",
  }

  return (
    <div style={headerStyle}>
      <Space align="center" size={12}>
        <Button type="text" onClick={props.toggleMenuCallback} icon={<MenuOutlined />} />
        <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
          <FireOutlined style={{ fontSize: 24 }} />
          {!screens.xs && (
            <Typography.Text strong style={{ fontSize: 16 }}>
              سامانه واحد گاز کردستان
            </Typography.Text>
          )}
        </Link>
      </Space>

      <Space align="center" size={8}>
        {screens.md ? (
          <Input.Search placeholder={props.t ? props.t("Search ...") : "Search ..."} allowClear style={{ width: 260 }} />
        ) : (
          <Popover
            content={<div style={{ width: 220 }}><Input.Search autoFocus placeholder={props.t ? props.t("Search ...") : "Search ..."} allowClear /></div>}
            trigger="click"
            open={searchOpen}
            onOpenChange={setSearchOpen}
            placement="bottomRight"
          >
            <Button type="text" icon={<SearchOutlined />} />
          </Popover>
        )}

        <Tooltip title={props.t ? props.t("Fullscreen") : "Fullscreen"}>
          <Button type="text" onClick={toggleFullscreen} icon={<FullscreenOutlined />} />
        </Tooltip>

        <NotificationDropdown userInfo={props.userInfo} />
        <ProfileMenu />
      </Space>
    </div>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType, leftSideBarTheme } =
    state.Layout
  return {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
    leftSideBarTheme,
    userInfo: state.USERs.userInfo,
  }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
